<template>
  <b-container fluid>
    <b-breadcrumb style="background-color: #f8f9fa">
      <b-breadcrumb-item to="/dashboard">
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{$t("dashboard")}}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>{{$t("approvals.myApprovals")}}</b-breadcrumb-item>
    </b-breadcrumb>
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-card
        no-body
        class="shadow-sm pt-0 pl-0 pr-0 m-4 mb-0"
      >
        <b-navbar
          class="background-white"
          toggleable="lg"
        >
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          <b-navbar-brand
            href="#"
            class="text-dark"
          >
            <strong>{{$t("approvals.approvals")}}</strong>
          </b-navbar-brand>

          <b-collapse
            id="nav-collapse"
            is-nav
          >
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  size="sm"
                  class="mr-2"
                  variant="outline-primary"
                  @click="addApprovalPage('/employee-approvals-user-form')"
                >
                  <!-- @click="showAddApprovalModal" -->
                  {{$t("approvals.addApprovals")}}
                </b-button>
                <b-button
                  variant="outline-info"
                  size="sm"
                  class="mr-2"
                  @click="reloadTable"
                >
                  {{$t("remingtonSeed.reload")}}
                </b-button>
                <b-form-group>
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      :placeholder="$t('remingtonSeed.search')"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        :disabled="!filter"
                        @click="filter = ''"
                      >{{$t("remingtonSeed.clear")}}</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
        <b-table
          class="main-table"
          hover
          striped
          sticky-header="calc(100vh - 395px)"
          fixed
          :busy.sync="isLoading"
          ref="table"
          id="employee-gift-table"
          :fields="staticFields"
          :items="getApprovalsData"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          no-sort-reset
        >
          <template v-slot:cell(created_at)="data">{{
            createdAtDate(data.item.created_at)
          }}</template>
          
          <template v-slot:cell(title)="data">
            <p
              class="link-text"
              @click="setUserTaskUrl(data.item)"
            >
              {{ JSON.parse(data.item.title)[selectedLanguage] }}
            </p>
          </template>
          <template v-slot:cell(amount)="data">
            <p>{{ amountFormmater(data) }}</p>
          </template>
          <template v-slot:cell(status)="data">
            <b-badge
              v-if="data.item.status == 1"
              variant="info"
            >{{$t("remingtonSeed.Open")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 2"
              variant="success"
            >{{$t("approvals.Completed")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 3"
              variant="warning"
            >{{$t("remingtonSeed.onHold")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 4"
              variant="success"
            >{{$t("approvals.Approved")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 5"
              variant="danger"
            >{{$t("approvals.Rejected")}}</b-badge>
            <b-badge
              v-else-if="data.item.status == 6"
              variant="warning"
            >{{$t("approvals.InReview")}}</b-badge>
            <font-awesome-icon v-if="parseInt(data.item.filesCount) > 0" class="ml-2" icon="paperclip" />
          </template>
        </b-table>
        <template v-slot:footer>
          <b-row>
            <b-col cols="2">
              <b-form-select
                v-model="perPage"
                id="perPageSelect"
                size="sm"
                :options="pageOptions"
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <p class="text-center">
                {{$t("remingtonSeed.showingResults")}}
                <b>{{ fromRows }}</b> {{$t("remingtonSeed.to")}}
                <b>{{ toRows }}</b>
              </p>
            </b-col>
            <b-col cols="4">
              <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                :first-text="$t('remingtonSeed.first')"
                :prev-text="$t('remingtonSeed.prev')"
                :next-text="$t('remingtonSeed.next')"
                :last-text="$t('remingtonSeed.last')"
                aria-controls="employee-gift-table"
              ></b-pagination>
            </b-col>
          </b-row>
        </template>
      </b-card>
    </b-overlay>
    <!-- <AddApprovalModal /> -->
  </b-container>
</template>
<script>
import { validationMixin } from "vuelidate";
import { HTTP } from "../../../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import { EventBus } from "@/event-bus.js";
// import AddApprovalModal from "../../../components/newEmployeeComponents/addApprovalModal/addApprovalModal.vue";
export default {
  name: "GiftsTab",
  mixins: [validationMixin],
  components: {
    // AddApprovalModal,
  },
  data () {
    return {
      selectedLanguage: 'english',
      isLoading: false,
      totalRows: 0,
      filter: null,
      perPage: 10,
      fromRows: 0,
      toRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      staticFields: [],
      approvalTypeId: null,
      processing: false,
      counter: 1,
      interval: null,
    };
  },
  computed: {
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.staticFields = [
      { key: "created_at", label: this.$t("remingtonSeed.dateFiled"), sortable: true },
      { key: "title", label: this.$t("approvals.approvalType"), sortable: true },
      { key: "amount", label: this.$t("approvals.ammount"), sortable: false },
      { key: "status", label: this.$t("remingtonSeed.status"), sortable: true },
    ];
    this.$store.state.selectedTaskType = 'My Approvals';
    this.selectedLanguage = localStorage.getItem( "formDefaultLanguage" );
    localStorage.setItem( 'selected_task_type', this.$store.state.selectedTaskType );
  },
  methods: {
    showAddApprovalModal () {
      EventBus.$emit( "onAddApprovalModal", "" );
    },
    OpenDetailPage ( url ) {
      this.$router.push( url );
    },
    addApprovalPage ( url ) {
      this.$router.push( url );
    },
    setUserTaskUrl ( data ) {
      this.OpenDetailPage( '/gifts-approval/' + data.id + '/2' )
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    amountFormmater ( data ) {
      let amount = data.item.amount.replace( /\D/g, "" );
      return (amount == '') ? 'N/A' : '$'+amount.replace( /\B(?=(\d{3})+(?!\d))/g, "," );
    },
    reloadTable () {
      this.$root.$emit( "bv::refresh::table", "employee-gift-table" );
    },
    async getApprovalsData () {
      let employeeId = localStorage.getItem( "employeeId" );
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
        employee_id: employeeId,
      };
      this.isLoading = true;
      let result = HTTP( "post", "api/v1/approvals/get", formData );

      return result
        .then( ( response ) => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          this.fromRows = response.data.from || 0;
          this.toRows = response.data.to || 0;
          this.$store.state.employeeDashboardGiftsLazyLoad = false;
          return items;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
  },
};
</script>
<style scoped>
.link-text {
  color: rgb(0 123 255);
  text-decoration: none;
  background-color: rgb(0 0 0 / 0%);
  cursor: pointer;
}
.link-text:hover {
  color: rgb(0 86 179);
  text-decoration: underline;
}
</style>